import { InputHTMLAttributes, forwardRef } from 'react';
import { AlertCircle } from 'lucide-react';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  helperText?: string;
}

const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ label, error, helperText, className = '', ...props }, ref) => {
    return (
      <div className="w-full">
        {label && (
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            {label}
            {props.required && <span className="text-red-500 dark:text-red-400 ml-1">*</span>}
          </label>
        )}
        <input
          ref={ref}
          className={`w-full px-4 py-2 border-2 rounded-lg focus:outline-none focus:ring-0 transition-colors bg-white dark:bg-metallic-800 text-gray-900 dark:text-white ${
            error
              ? 'border-red-300 dark:border-vivid-pink-bright focus:border-red-500 dark:focus:border-vivid-pink-light'
              : 'border-gray-300 dark:border-vivid-purple-dark/50 focus:border-primary-500 dark:focus:border-vivid-cyan-bright'
          } disabled:bg-gray-50 dark:disabled:bg-metallic-900 disabled:cursor-not-allowed ${className}`}
          {...props}
        />
        {error && (
          <div className="flex items-center mt-1 text-sm text-red-600 dark:text-red-400">
            <AlertCircle className="w-4 h-4 mr-1" />
            {error}
          </div>
        )}
        {helperText && !error && (
          <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">{helperText}</p>
        )}
      </div>
    );
  }
);

Input.displayName = 'Input';

export default Input;

// Made with Bob
